import { useAuth } from "@/context/auth-context";
import useGetPaymentCredentials from "@/features/payment-credentials/useGetPaymentCredentials";
import AddCreditCardIframe from "./AddCreditCardIframe";
import PageLoader from "../../../../../../components/ui/PageLoader";
import { useLoaderData } from "@tanstack/react-router";

function SoftpointIframeDataFetcher() {
	const { location_id } = useLoaderData({ from: "__root__" });
	const paymentCredsQuery = useGetPaymentCredentials(location_id);
	const { user } = useAuth();

	return (
		<PageLoader isFullscreenLoading={true} query={paymentCredsQuery}>
			{(session) => {
				return (
					<AddCreditCardIframe
						user={user}
						iframeAccessToken={session.iframe_access_token}
						locationId={location_id}
					/>
				);
			}}
		</PageLoader>
	);
}

export default SoftpointIframeDataFetcher;
